import { useEffect, useRef, useState } from 'react'

const useReadMoreHook = (channelName?: string) => {
    const [isFolded, setIsFolded] = useState(false)
    const [isReadMoreShowed, setIsReadMoreShowed] = useState(false)
    const containerRef = useRef<HTMLDivElement>(null)
    const descriptionRef = useRef<HTMLDivElement>(null)

    const maxDescriptionHeight = 60
    useEffect(() => {
        setIsFolded(false)
        const handleResize = () => {
            const refElement = descriptionRef.current
            if (refElement) {
                //check Description Height
                const height = refElement.offsetHeight

                setIsReadMoreShowed(height > maxDescriptionHeight)
            }
        }
        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [channelName])

    if (containerRef.current) {
        if (isFolded) {
            document.getElementById('anchor')?.scrollIntoView({
                block: 'end',
                behavior: 'smooth',
            })
        } else if (!isFolded) {
            document.getElementById('playerContainer')?.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }
    }
    return {
        isReadMoreShowed,
        containerRef,
        isFolded,
        setIsFolded,
        descriptionRef,
    }
}

export default useReadMoreHook
